import React, {
    Component,
    useState
} from 'react'

import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles(theme => ({
  formControl: {},
  xRoot: {
    '.MuiInput-underline:after': {
        // borderBottom: '2px solid #1976d2',
        borderBottom: '2px solid red',
    }
  },
  xInput: {
    '&.Mui-focused.MuiInput-underline:after': {
        borderBottom: '2px solid #1976d2',
    }
  },
  xLabel: {
    whiteSpace: 'nowrap',
    '&.Mui-focused': {
        color: '#1976d2',
    }
  },
}));

const XInput = (props) => {
    const classes = useStyles();
    const [error, setError] = useState(false);

    return (
        <TextField
            key={`${props.name}`}
            className="input"
            error={error}
            id={props.name}
            name={props.name}
            label={props.label}
            type="text"
            value={props.value || ''}
            defaultValue={props.value || ''}
            onChange={e=>{
                setError(false);
                props.handleChange(e.target.value);
            }}
            onFocus={e=>{
                setError(false);
            }}
            onBlur={e=>{
                if(props.required && !props.value){
                    setError(true);
                }
            }}
            helperText={!error ? props.helperText : `This field is required.`}
            classes={{className: classes.xInput}}
            SelectProps={{
                native: false,
            }}
            /* inputProps={{className: classes.xInputChildInput}} */
            InputProps={{className: classes.xInput}}
            InputLabelProps={{className: classes.xLabel}}
            FormHelperTextProps={{}}
            select={props.choices ? true : false}
            SelectProps={{MenuProps: {disableScrollLock: true}}}
            {...props}
        >
            {props.choices && props.choices.map(choice=>(
                <MenuItem key={choice.value} value={choice.value}>
                    {choice.label}
                </MenuItem>
            ))}
        </TextField>
    )
}

export default XInput;